import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import styled from "styled-components";
import themes from "../theme";

const styles = createMuiTheme({
  overrides: {
    MuiOutlinedInput: {
      input: {
        padding: "11px 10px 12px 10px",
        borderRadius: "3px",
        "&:disabled": {
          background: themes.palette.LIGHTGREY3
        }
      },
      root: {
        borderColor: themes.palette.DARKGREY3,
        background: themes.palette.WHITE,
        "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
          borderColor: themes.palette.DARKGREY3
        },
        "&$focused svg path": {
          fill: themes.palette.PRIMARY
        },
        "&$disabled svg": {
          opacity: `.5`
        },
        "&$disabled $notchedOutline": {
          borderColor: themes.palette.DISABLEDBORDER
        },
        "&$focused $notchedOutline": {
          borderColor: themes.palette.PRIMARY
        },
        "&$error": {
          borderColor: themes.palette.PRIMARY
        }
      }
    }
  },
  typography: {
    useNextVariants: true
  }
});

const InputComp = ({ className, label, id, ...rest }) => {
  const customId = `id_${Math.random()}`;
  return (
    <div className={className}>
      <label htmlFor={id || customId}>{label}</label>
      <MuiThemeProvider theme={styles}>
        <TextField id={id || customId} variant="outlined" {...rest} />
      </MuiThemeProvider>
    </div>
  );
};

InputComp.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string
};

InputComp.defaultProps = {
  className: "",
  classes: {},
  label: "",
  id: ""
};

export const Input = styled(InputComp)`
  display: flex;
  flex-direction: column;
  label {
    color: ${/* istanbul ignore next */ ({ theme }) => theme.palette.DARKGREY2};
    font-family: ${
      /* istanbul ignore next */ ({ theme }) => theme.fontFamily.BOLD
    };
    padding-bottom: 5px;
  }
  input {
    font-family: ${
      /* istanbul ignore next */ ({ theme }) => theme.fontFamily.REGULAR
    };
    font-size: ${
      /* istanbul ignore next */ ({ theme }) => theme.fontSize.MEDIUM
    };
    line-height: 1em;
    background: ${({ theme }) => theme.palette.WHITE};  
`;

Input.displayName = "Input";
